const shortTimeout = (callback: () => void) => setTimeout(() => callback(), 100);

export default shortTimeout;
